import { render, staticRenderFns } from "./SystemBuildingAddressView.vue?vue&type=template&id=31a34357&scoped=true"
import script from "./SystemBuildingAddressView.vue?vue&type=script&lang=js"
export * from "./SystemBuildingAddressView.vue?vue&type=script&lang=js"
import style0 from "./SystemBuildingAddressView.vue?vue&type=style&index=0&id=31a34357&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a34357",
  null
  
)

export default component.exports